function getPathnameWithNewLang(pathname: string, newLang: string) {
  const regex1 = /^\/[A-Za-z]{2}\//gim; // ex: /en/ or /fr/
  const regex2 = /^\/[A-Za-z]{2}$/gim; // ex: /en or /fr

  if (regex1.test(pathname)) {
    return pathname.replace(regex1, `/${newLang}/`);
  } else if (regex2.test(pathname)) {
    return pathname.replace(regex2, `/${newLang}`);
  } else {
    return `/${newLang}${pathname === "/" ? "" : pathname}`;
  }
}

export { getPathnameWithNewLang };
